// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-box{
    display: flex;
    flex-wrap: wrap;
}

.submit-btn{
    margin-left: 23px;
}

.TopBox-Add-iser-2{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 30px;
}

.add-user-inside{
    width: 100%;
}

.image-section-box{
    border: 1px solid #cccccc;
    border-radius: 7px;
    padding: 9px;
}

.auto-resize-textarea-10 {
  min-height: 50px;
  max-height: 200px;
  height: 50px !important;
  overflow-y: scroll;
  width: 195px;
  resize: none;
  display: block;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  }

  .error-msg{
    font-size: 10px;
  }

  .ql-toolbar.ql-snow{
    border-radius: 5px 5px 0 0;
  }

  .ql-toolbar.ql-snow + .ql-container.ql-snow{
    border-radius: 0 0 5px 5px;
    height: 80px;
  }

  .description-box-area{
    margin-top: 30px !important;
  }

  .description-image-container{
    display: flex;
    align-items: flex-end;
    gap: 20px;
    margin-top: 25px;
    flex-wrap: wrap;
  }

  .image-inside-2{
    max-width: 283px;
    width: 100%;
    height: 75px;
    margin-top: 3px;
    object-fit: cover;
  }


  .image-input-class-22[type="file"] {
    height: auto;
    overflow: hidden;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
}

.image-input-class-22[type="file"]+.attach-icon {
  background: #fff;
  color: #000;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Rubik', sans-serif;
  font-size: inherit;
  font-weight: 500;
  outline: none;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;
  width: 239px;
  text-align: left;
  height: 50px;
  display: flex !important;
  align-items: center;
  gap: 2px;
  padding-left: 0;
}

/* input[type="file"]+.attach-icon:hover {
    background-color: darken(#5569ff, 10%);
} */

.new-user-class{
  width: 46%;
}
.label-area-10{
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/content/applications/Home/AddHome/home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;;EAGA;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".field-box{\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.submit-btn{\n    margin-left: 23px;\n}\n\n.TopBox-Add-iser-2{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 30px;\n}\n\n.add-user-inside{\n    width: 100%;\n}\n\n.image-section-box{\n    border: 1px solid #cccccc;\n    border-radius: 7px;\n    padding: 9px;\n}\n\n.auto-resize-textarea-10 {\n  min-height: 50px;\n  max-height: 200px;\n  height: 50px !important;\n  overflow-y: scroll;\n  width: 195px;\n  resize: none;\n  display: block;\n  padding: 4px 8px;\n  border-radius: 8px;\n  border: 1px solid #c4c4c4;\n  }\n\n  .error-msg{\n    font-size: 10px;\n  }\n\n  .ql-toolbar.ql-snow{\n    border-radius: 5px 5px 0 0;\n  }\n\n  .ql-toolbar.ql-snow + .ql-container.ql-snow{\n    border-radius: 0 0 5px 5px;\n    height: 80px;\n  }\n\n  .description-box-area{\n    margin-top: 30px !important;\n  }\n\n  .description-image-container{\n    display: flex;\n    align-items: flex-end;\n    gap: 20px;\n    margin-top: 25px;\n    flex-wrap: wrap;\n  }\n\n  .image-inside-2{\n    max-width: 283px;\n    width: 100%;\n    height: 75px;\n    margin-top: 3px;\n    object-fit: cover;\n  }\n\n\n  .image-input-class-22[type=\"file\"] {\n    height: auto;\n    overflow: hidden;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    opacity: 0;\n}\n\n.image-input-class-22[type=\"file\"]+.attach-icon {\n  background: #fff;\n  color: #000;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: 'Rubik', sans-serif;\n  font-size: inherit;\n  font-weight: 500;\n  outline: none;\n  position: relative;\n  transition: all 0.3s;\n  vertical-align: middle;\n  width: 239px;\n  text-align: left;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n  gap: 2px;\n  padding-left: 0;\n}\n\n/* input[type=\"file\"]+.attach-icon:hover {\n    background-color: darken(#5569ff, 10%);\n} */\n\n.new-user-class{\n  width: 46%;\n}\n.label-area-10{\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
